import api from '../config/api';

export interface Event {
  id: number;
  titre: string;
  description: string;
  type_event: string;
  section: 'VCN' | 'HDR' | 'SANTE';
  date_event: string;
  heure_debut: string;
  heure_fin?: string;
  lieu: string;
  photo?: string;
  status?: string;
  status_auto?: string; // Statut calculé automatiquement
  url_slug: string;
  nombre_vues: number;
  nombre_likes: number;
  nombre_commentaires: number;
  is_liked: boolean;
  commentaires_approuves?: Comment[];
  created_at: string;
  updated_at?: string;
}

export interface Comment {
  id: number;
  utilisateur: {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
  };
  contenu: string;
  approuve?: boolean;
  created_at: string;
  updated_at?: string;
}

export interface EventFilters {
  type_event?: string;
  section?: 'VCN' | 'HDR' | 'SANTE' | '';
  date_event?: string;
  date_event__gte?: string;
  ordering?: string;
  page?: number;
  page_size?: number;
  search?: string;
}

export const eventService = {
  getAll: async (filters?: EventFilters): Promise<{ results: Event[]; count?: number; next?: string; previous?: string }> => {
    const response = await api.get('/events/events/', { params: filters });
    return response.data;
  },

  getById: async (idOrSlug: number | string): Promise<Event> => {
    // idOrSlug peut être un ID numérique ou un url_slug (titre-id)
    const response = await api.get(`/events/events/${idOrSlug}/`);
    return response.data;
  },

  like: async (idOrSlug: number | string): Promise<{ liked: boolean }> => {
    const response = await api.post(`/events/events/${idOrSlug}/like/`);
    return response.data;
  },

  comment: async (idOrSlug: number | string, contenu: string): Promise<Comment> => {
    const response = await api.post(`/events/events/${idOrSlug}/commenter/`, { contenu });
    return response.data;
  },

  // Modifier un commentaire
  updateComment: async (commentId: number, contenu: string): Promise<Comment> => {
    const response = await api.put(`/events/commentaires/${commentId}/`, { contenu });
    return response.data;
  },

  // Supprimer un commentaire
  deleteComment: async (commentId: number): Promise<void> => {
    await api.delete(`/events/commentaires/${commentId}/`);
  },

  // Récupérer tous les commentaires d'un événement (pour admin)
  getComments: async (eventId: number): Promise<Comment[]> => {
    const response = await api.get(`/events/commentaires/?event=${eventId}`);
    return response.data.results || response.data || [];
  },

  // Incrémenter les vues
  incrementView: async (idOrSlug: number | string): Promise<void> => {
    await api.post(`/events/events/${idOrSlug}/increment_view/`);
  },
};

